
import Draw from 'ol/interaction/Draw';
import EventType from 'ol/events/EventType';

class DrawGeometry extends Draw {

    constructor(options) {
        super(options);
    }

    handleEvent(mapBrowserEvent) {
        if (mapBrowserEvent.type == EventType.KEYDOWN) {
            this.processKeyDown(mapBrowserEvent.originalEvent);
        }
        return super.handleEvent(mapBrowserEvent);
    }

    processKeyDown(keyEvent) {
        switch (keyEvent.keyCode) {
            case 27:
                this.abortDrawing();
                break;
            case 46:
                this.removeLastPoint();
                break;
            default:
                // nop;
        }
    }
}

export default DrawGeometry;
